import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextTreasury } from '../Treasury';
import { Company } from '../../../../models/company.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';

export interface BankStatementPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null
};

const BankStatementPage: React.FunctionComponent<BankStatementPageProps> = props => {
  const {setRoute, companyForUser, treasuryAccountsForCompany} = UseOutletContextTreasury()

  return (
    <Outlet context={{setRoute, companyForUser, treasuryAccountsForCompany}}></Outlet>
  );
}

export function UseOutletContextBankStatement() {
  return useOutletContext<ContexType>()
};

export default BankStatementPage;
